export default {
  getMatches: ({
    tournaments = {}, categories = {}, activeSport = {}, matches = [],
  }) => {
    const tournamentsFiltered = _.sortBy(
      _.filter(tournaments, { idSport: activeSport.id }),
      ['position', 'name'],
    );

    const categoriesFiltered = _.sortBy(
      _.filter(categories, c => c.idSport === activeSport.id),
      ['position', 'name'],
    );


    let offer = [];
    _.forEach(categoriesFiltered, (category) => {
      _.assign(category, {
        tournaments: _.filter(tournamentsFiltered, { idCategory: category.id }),
      });
      _.forEach(category.tournaments, (tour) => {
        offer = [...offer, ..._.sortBy(_.filter(matches, { idTournament: tour.id }), ['timestamp', 'name'])];
      });
    });

    return offer;
  },
  getTopOffer: (state) => {
    const {
      sports, categories, tournaments, matches,
    } = state;

    const topOffer = {
      sports: sports || {},
      categories: categories || {},
      tournaments: tournaments || {},
      matches: matches || [],
    };

    let offer = [];
    _.forEach(categories, (category) => {
      _.assign(category, { tournaments: _.filter(tournaments, { idCategory: category.id }) });
      _.forEach(category.tournaments, (tour) => {
        offer = [...offer, ..._.sortBy(_.filter(matches, { idTournament: tour.id }), ['timestamp', 'name'])];
      });
    });

    topOffer.matches = offer;
    return topOffer;
  },
  getMetaSports: state => _.values(state.sports),
  getOutrightsSports: state => _.sortBy(state.outrightsSports, ['position']),
  getOutrightsSport: state => sportId => state.outrightsSports[sportId],
  getOutrightsCategories: state => _.sortBy(state.outrightsCategories, ['position']),
  getOutrightsTournaments: state => _.sortBy(state.outrightsTournaments, ['position']),
  getOutrightsTournament: state => tournamentId => state.outrightsTournaments[tournamentId],
  getOutrightsMatches: state => _.sortBy(state.outrightsMatches, ['position']),
  getMetaCategories: state => state.categories,
  getBetsBySportId: state => ({ sportId, limit }) => {
    const bets = _.orderBy(_.filter(state.bets, { idSport: sportId }), ['position']);
    bets.length = bets.length > limit ? limit : bets.length;
    return bets;
  },
  getSportById: state => idSport => state.sports[idSport],
  getBetById: state => idBet => state.bets[idBet],
  getAllBets: state => state.bets,
  getTournamentById: state => tournamentId => state.tournaments[tournamentId],
  getCategoryById: state => categoryId => state.categories[categoryId],
  getTournamentsBySportId: state => (sportId) => {
    const tournamentsObj = {};
    const tournaments = _.filter(state.tournaments, { idSport: sportId });
    _.forEach(tournaments, (item) => {
      tournamentsObj[item.id] = item;
    });
    return tournamentsObj;
  },
  getCategoriesBySportId: state => sportId => _.sortBy(_.filter(state.categories, { idSport: sportId }), ['position']),
  getMetaLoaded: state => state.metaLoaded,
  getOfferLoaded: state => state.offerLoaded,
  getActiveMatch: state => state.activeMatch,
  getActiveSport: state => state.activeSport,
  getActiveTournament: state => state.activeTournament,
  getActiveSportByRoute: state => (routeName) => {
    const offerRoutes = ['TopOffer', 'Offer'];
    const index = _.indexOf(offerRoutes, routeName);

    return index !== -1 ? state.activeSport : state.activeOutrightsSport;
  },
  getSportsByRoute: state => (routeName) => {
    const offerRoutes = ['TopOffer', 'Offer'];
    const index = _.indexOf(offerRoutes, routeName);

    return index !== -1 ? _.sortBy(_.values(state.sports), ['position']) : _.sortBy(state.outrightsSports, ['position']);
  },
  getActiveCategory: state => state.activeCategory,
  getActiveOutrightsSport: state => state.activeOutrightsSport,
  getBetGroupsBySport: state => idSport => _.sortBy(_.filter(state.betGroups, { idSport }), ['position']),
  getBetGroupsForActiveMatch: (state, getters) => {
    const match = state.activeMatch;
    let betGroups = [];
    if (match) {
      betGroups = getters.getBetGroupsBySport(match.idSport);
    }
    const groups = [];
    if (match && match.bets) {
      // Only show bet groups that have active bets in current match
      match.bets.forEach((bet) => {
        betGroups.forEach((group) => {
          if (group.bets.indexOf(bet.id) !== -1) {
            const foundGroup = _.findIndex(groups, { id: group.id });
            if (foundGroup === -1) {
              groups.push(group);
            }
          }
        });
      });
      return _.sortBy(groups, ['position']);
    }
    return [];
  },
  getSideViewMatches: (state) => {
    const sports = _.sortBy(state.sports, ['position', 'name']);
    const tournamentsObj = { ...state.tournaments };
    const categoriesObj = { ...state.categories };
    const matches = _.sortBy(state.matches, ['timestamp', 'name']);

    const groups = _.groupBy(matches, 'idTournament');
    _.forEach(groups, (value, key) => _.assign(tournamentsObj[key], { matches: value }));

    const tournaments = _.sortBy(_.filter(tournamentsObj, tournament => tournament.parent), ['position', 'name']);

    const categoryGroups = _.groupBy(tournaments, 'idCategory');
    _.forEach(categoryGroups, (value, key) => _.assign(categoriesObj[key], { tournaments: value }));

    const categories = _.sortBy(categoriesObj, ['position', 'name']);

    const sportGroups = _.groupBy(categories, 'idSport');

    _.forEach(sports, (sport) => {
      let tours = [];
      _.forEach(sportGroups[sport.id], (category) => {
        tours = [...tours, ...category.tournaments];
      });
      _.assign(sport, { tournaments: tours });
    });

    return sports;
  },
  getBetslip: state => state.betslip,
  getBetslipBets: state => state.betslip.bets,
  getBetslipMatchIds: state => state.betslip.bets.map(bet => bet.matchId),
  getBankerBets: state => _.filter(state.betslip.bets, { banker: true }),
  getBetslipConfig: (state) => {
    if (state && state.productConfig) {
      const { ticket, odds, taxes } = state.productConfig;

      return {
        ticket,
        odds,
        taxes,
      };
    }

    return null;
  },
  getBetslipRules: (state) => {
    if (state && state.productConfig) {
      return state.productConfig.rules;
    }
    return [];
  },
  getBonusConfig: (state) => {
    if (state && state.bonusConfig) {
      return state.bonusConfig;
    }

    return [];
  },
  getBetslipShow: (state) => {
    if (state && state.betslip) {
      return state.betslip.showBetslip;
    }

    return false;
  },
  getSingleStake: (state) => {
    const { bets, stake } = state.betslip;
    if (bets) return (parseFloat(stake) / bets.length).toFixed(2);
    return 1;
  },
  getBetslipSystems: (state) => {
    if (state && state.betslip) {
      return state.betslip.systems;
    }
    return [];
  },
  getTotalOdds: (state) => {
    let total = 1;

    const { bets } = state.betslip;

    bets.forEach((bet) => {
      total *= parseFloat(bet.oddValue);
    });

    return bets.length ? total : 0;
  },
  getPossibleWinnings: (state) => {
    const { betslip } = state;
    return betslip.possibleWinnings;
  },
  getBetslipTabs: state => state.betslip.tabs,
  getBetslipActiveTab:
    state => _.find(
      state.betslip.tabs,
      item => parseInt(item.id, 10) === parseInt(state.betslip.type, 10),
    ),
  getActiveOddType: (state) => {
    // 1: Decimal
    // 2: Fractional
    // 3: American
    const convertMap = {
      decimal: 1,
      fractional: 2,
      american: 3,
    };

    if (state && state.productConfig) {
      const { odds } = state.productConfig;

      return convertMap[odds.active.toLowerCase()] || 1;
    }

    return 1;
  },
  getCheckedTicket: state => state.checkedTicket,
  getMoneyDenominations: state => state.betslip.moneyDenominations,
  getMoneyBalance: state => state.balance,
  getDevice: state => state.device,
  getCompany: state => state.company,
  getEnv: state => state.env,
  getCompanyConfig: state => state.companyConfig,
  getProductConfig: state => state.productConfig,
  getCpvUuid: state => state.cpvUuid,
  getTranslations: state => state.translations,
  getTranslation: state => key => (state.translations ? state.translations[key] || key : key),
  getStatsModalState: state => state.modalState,
  getChildTournamentsForOffer:
    state => superTourId => _.filter(state.tournaments, { parent: superTourId }),
  getApplicationReady: state => !_.isNil(state.device)
    && !_.isNil(state.company) && !_.isNil(state.cpvUuid),
  getServerServiceTimeout: state => state.serverServiceTimeout,
  getClientServiceTimeout: state => state.clientServiceTimeout,
  getClientIntervalID: state => state.clientIntervalID,
  getServerTimeoutID: state => state.serverTimeoutID,
  getTicketUpdateStatusValues: state => state.ticketUpdateStatusValues,
  workingTimeBlocker: state => state.workingTimeBlocker,
  getOddType: state => state.oddType,
  getUserType: state => state.userType,
  taxes: state => state.taxes,
  alternativeStake: state => state.alternativeStake,
};
